import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=5c488797&scoped=true&"
import script from "./formBox.vue?vue&type=script&lang=js&"
export * from "./formBox.vue?vue&type=script&lang=js&"
import style0 from "./formBox.vue?vue&type=style&index=0&id=5c488797&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c488797",
  null
  
)

export default component.exports